import { useCallback, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import ClientInfo from '@pages/partners-registration/client-info/ClientInfo';
import ClientAddress from '@pages/partners-registration/client-address/ClientAddress';
import CompanyInfo from '@pages/partners-registration/company-info/CompanyInfo';
import Message from '@pages/partners-registration/message/Message';
import Footer from '@pages/partners-registration/footer/Footer';


const PartnersRegistration = () => {
	const { t } = useTranslation('forms');

	const formRef = useRef<HTMLDivElement>(null);

	const scrollToTop = useCallback(() => {
		formRef?.current?.scrollIntoView({ behavior: 'smooth' });
	},[ formRef ]);

	return (
		<div className="app-page partners-registration-page" ref={formRef}>
			
			<h1>{t('partnersRegistration.header')}</h1>

			<div className='intro-text'>
				<p>{t('partnersRegistration.introText')}</p>
			</div>

			<ClientInfo />

			<ClientAddress />

			<CompanyInfo />

			<Message />

			<Footer scrollToTop={scrollToTop} />

		</div>
	);
};

export default PartnersRegistration;